export interface Session {
    token: string;
    /// Renova o token de acesso quando ele vence, sem pedir a senha.
    refreshToken: string;
    userId: string;
    name: string;
    email: string;
    /// Momento em que o token de acesso expira, em milissegundos.
    expiresAt: number;
}

const KEY = 'crm.sessao';

/// localStorage é o compromisso desta POC; em produção, cookie httpOnly é mais seguro.
export const authStorage = {
    read(): Session | null {
        try {
            const raw = localStorage.getItem(KEY);

            if (!raw) return null;

            const session = JSON.parse(raw) as Session;

            // Token de acesso vencido não encerra a sessão: o refresh renova; sem ele, cai no login.
            if (!session.token || !session.refreshToken) {
                localStorage.removeItem(KEY);
                return null;
            }

            return session;
        } catch {
            return null;
        }
    },

    write(session: Session) {
        try {
            localStorage.setItem(KEY, JSON.stringify(session));
        } catch {
            // Navegador com armazenamento bloqueado: a sessão vive só nesta aba.
        }
    },

    clear() {
        try {
            localStorage.removeItem(KEY);
        } catch {
            // Nada a fazer: já não há o que limpar.
        }
    },
};
